import {Injectable} from "@angular/core";
import {ResourceManagerService} from "./resource.manager.service";
import {Texture} from "three/src/textures/Texture";
import {PMREMGenerator, Scene, WebGLRenderer} from "three";



@Injectable({providedIn: 'root'})
export class EnvironmentService {

    private defaultEnvironmentHDR: string = 'assets/environment-map/modern_buildings_xxs.hdr';
    private defaultEnvironment : Texture;

    private isInited = false;

    constructor(
        private resourceManager: ResourceManagerService,
    ) {}

    init(scene : Scene, renderer : WebGLRenderer): Promise<void> {

        if(this.isInited){
            return Promise.resolve();
        }
        this.isInited = true;

        if (this.defaultEnvironment) {
            scene.environment = this.defaultEnvironment;
            scene.background = this.defaultEnvironment;
            return Promise.resolve();
        }

        return this.loadEnvironmentHDR(this.defaultEnvironmentHDR, scene, renderer);
    }

    public getDefaultEnvironment() : Texture {
        return this.defaultEnvironment;
    }

    private loadEnvironmentHDR(hdrToLoad: string, scene : Scene, renderer : WebGLRenderer): Promise<void>{
        // Ladataan HDR vain kerran ResourceManagerin kautta
        return this.resourceManager.loadResource(
            this.defaultEnvironmentHDR,
            'hdr',
            scene.uuid,
            false
        ).then((resource) => {
            // Varmistetaan, että saatu resurssi on Texture
            if (!this.isTextureResource(resource)) {
                const errorMsg = "Ladattu HDR-resurssi ei ole tekstuuri!";
                console.error(errorMsg);

                return Promise.reject(errorMsg);
            }

            // Generoidaan PMREM
            const pmremGenerator = new PMREMGenerator(renderer);
            pmremGenerator.compileEquirectangularShader();

            // Luo PMREM-tekstuurin
            const envMap = pmremGenerator.fromEquirectangular(resource).texture;
            pmremGenerator.dispose();



            // Aseta sceneen environment ja background
            //scene.environment = envMap;
            //scene.background = envMap;

            // Tallennetetaan defaultEnvironment
            this.defaultEnvironment = envMap;

            return Promise.resolve();
        }).catch((error) => {
            console.error("HDR-tekstuurin lataus epäonnistui:", error);
            return Promise.reject(error);
        });
    }

    private isTextureResource(value: unknown): value is Texture {
        // Kolmejs-tekstuurilla on `isTexture = true`
        return !!value && (value as any).isTexture === true;
    }

    public clearEnvironment() : void {
            this.defaultEnvironment = undefined;
            this.isInited = false;
    }

}